import { useSelector } from 'react-redux';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';
import { userSelector } from 'src/redux/selectors';

type UseUserValuesReturnType = {
  userRole: ACCOUNT_ROLES;
  firstName: string;
  lastName: string;
  profileName: string;
  companyName: string;
  accessToken: string;
  country: string;
  email: string;
};

export const useUserValues = (): UseUserValuesReturnType => {
  const user = useSelector(userSelector);

  const userRole = user?.signInUserSession?.accessToken?.payload?.['cognito:groups']
    ?.filter((item) => item.startsWith('Role:'))
    .map((item) => item.replace('Role:', ''))
    .join(', ') as ACCOUNT_ROLES;

  const firstName = user?.attributes?.['custom:first_name'];
  const lastName = user?.attributes?.['custom:last_name'];
  const profileName = firstName && lastName ? `${firstName} ${lastName}` : null;

  const companyName = user?.attributes?.['custom:company_name'];
  const country = user?.attributes?.['custom:country'];
  const email = user?.attributes?.email;

  const accessToken = user?.signInUserSession?.accessToken?.jwtToken;

  return { userRole, firstName, lastName, profileName, companyName, accessToken, country, email };
};
